/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-14 18:28:42
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-14 23:52:57
 * @FilePath: /unifyxp-v2-store-portal/src/components/Icon/Delete/index.tsx
 */
import React from 'react';

import css from './css.module.less';

import { DeleteOutlined } from '@ant-design/icons';

const DeleteIcon = (props) => {
  const { disabled, onDelete, iconClassName } = props;
  return (
    <div className={css.endContainer}>
      <DeleteOutlined
        className={`${css.deleteIcon} ${iconClassName || ''}`}
        style={{
          cursor: disabled ? 'not-allowed' : undefined,
          color: disabled ? '#eee' : undefined,
        }}
        onClick={disabled ? null : onDelete}
      />
    </div>
  );
};
export default DeleteIcon;
